import { render, staticRenderFns } from "./interNews.vue?vue&type=template&id=8a1fa162&scoped=true"
import script from "./interNews.vue?vue&type=script&lang=js"
export * from "./interNews.vue?vue&type=script&lang=js"
import style0 from "./interNews.vue?vue&type=style&index=0&id=8a1fa162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1fa162",
  null
  
)

export default component.exports